export default "__VITE_ASSET__BVZmbWze__"